import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { ChartEnums } from "models/enums";
//#endregion
//#region components
import { ChartContainer } from "components/common";
import { useIncomingInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;

const IncomingInvoiceTotalByDueDateChart: React.FC = () => {
  const incomingInvoiceService = useIncomingInvoiceService();
  const labelFormatter = (label?: string) => {
    if (Number(label) === -1) return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Overdue);
    if (Number(label) === 20) return "20+";

    return label ?? "";
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Bar}
      chartAPIKey={GraphConstants.ChartKeys.IncomingInvoiceAmountByDueInDays}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.DaysPascal)}
      labelFormatter={labelFormatter}
      filterToAPIHandler={incomingInvoiceService.reportToAPIFilter}
      usePageFilter
      hideLegend
      yAxisTickUnit={ChartEnums.YAxisTickUnitType.Currency}
      useClickableChart
      onDataPointClickedSetFilter={(args?: any) => {
        const index: number | undefined = typeof args?.index === "number" ? args.index : undefined;
        if (index === undefined) return {};

        const today = new Date();

        if (index === 0) {
          return { dueDate: { end: today } };
        }

        if (index >= 1 && index <= 20) {
          const date = new Date();
          date.setDate(date.getDate() + (index - 1));
          return { dueDate: { start: date, end: date } };
        }

        if (index >= 21) {
          const date = new Date();
          date.setDate(date.getDate() + 20);
          return { dueDate: { start: date } };
        }

        return {};
      }}
      onBackgroundClickedSetFilter={{ dueDate: undefined }}
    />
  );
};

export default IncomingInvoiceTotalByDueDateChart;
